import { useEffect } from "react";
import { Instagram, Facebook } from "lucide-react";
import { Reveal } from "@/components/site/Motion";
import { useLang } from "@/lib/i18n";
import { INSTAGRAM_URL, FACEBOOK_URL, ELFSIGHT_APP_ID } from "@/components/site/ContactLinks";

export default function InstagramFeed() {
  const { t } = useLang();

  useEffect(() => {
    if (!ELFSIGHT_APP_ID) return;
    const src = "https://elfsightcdn.com/platform.js";
    if (!document.querySelector(`script[src="${src}"]`)) {
      const s = document.createElement("script");
      s.src = src;
      s.async = true;
      document.body.appendChild(s);
    }
    // Masque l'en-tête anglais du widget (doublon avec notre titre de section)
    const timer = setInterval(() => {
      const host = document.querySelector(`.elfsight-app-${ELFSIGHT_APP_ID} .es-embed-root`);
      if (host?.shadowRoot && !host.shadowRoot.querySelector("#pazapa-es-style")) {
        const style = document.createElement("style");
        style.id = "pazapa-es-style";
        style.textContent = ".es-header-container{display:none!important}";
        host.shadowRoot.appendChild(style);
        clearInterval(timer);
      }
    }, 400);
    const stop = setTimeout(() => clearInterval(timer), 20000);
    return () => {
      clearInterval(timer);
      clearTimeout(stop);
    };
  }, []);

  return (
    <section id="quotidien" className="py-16 md:py-24 bg-background" data-testid="instagram-section">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8">
        <Reveal>
          <div className="chip">{t("insta.chip")}</div>
          <h2 className="mt-4 font-heading text-3xl md:text-5xl leading-[1.05] max-w-2xl">
            {t("insta.title_1")} <span className="text-primary">{t("insta.title_accent")}</span>
          </h2>
          <p className="mt-4 text-lg text-foreground/75 leading-relaxed max-w-2xl">{t("insta.subtitle")}</p>
        </Reveal>
        <Reveal delay={0.08}>
          {ELFSIGHT_APP_ID ? (
            <div>
              <div
                className="mt-10 rounded-3xl bg-white border border-border p-4 md:p-6 overflow-hidden"
                data-testid="instagram-widget-card"
              >
                <div
                  className={`elfsight-app-${ELFSIGHT_APP_ID}`}
                  data-elfsight-app-lazy
                  data-testid="instagram-widget"
                />
              </div>
              <div className="mt-6 flex flex-wrap gap-3">
                <a
                  href={INSTAGRAM_URL}
                  target="_blank"
                  rel="noreferrer noopener"
                  data-testid="instagram-follow-btn"
                  className="pill-btn bg-primary text-primary-foreground hover:bg-primary/90"
                >
                  <Instagram className="w-4 h-4" strokeWidth={2.4} />
                  {t("insta.follow")}
                </a>
                <a
                  href={FACEBOOK_URL}
                  target="_blank"
                  rel="noreferrer noopener"
                  data-testid="facebook-follow-btn"
                  className="pill-btn border-2 border-foreground/25 text-foreground hover:border-primary hover:text-primary"
                >
                  <Facebook className="w-4 h-4" strokeWidth={2.4} />
                  Facebook
                </a>
              </div>
            </div>
          ) : (
            <div
              className="mt-10 rounded-3xl border-2 border-dashed border-border bg-muted/50 p-8 md:p-12 text-center"
              data-testid="instagram-placeholder"
            >
              <div className="mx-auto w-14 h-14 rounded-2xl grid place-items-center bg-white text-primary border border-border">
                <Instagram className="w-7 h-7" strokeWidth={2} />
              </div>
              <p className="mt-5 text-base text-foreground/70 max-w-md mx-auto leading-relaxed">{t("insta.soon")}</p>
              <div className="mt-6 flex flex-wrap justify-center gap-3">
                <a
                  href={INSTAGRAM_URL}
                  target="_blank"
                  rel="noreferrer noopener"
                  data-testid="instagram-follow-btn"
                  className="pill-btn bg-primary text-primary-foreground hover:bg-primary/90"
                >
                  <Instagram className="w-4 h-4" strokeWidth={2.4} />
                  {t("insta.follow")}
                </a>
                <a
                  href={FACEBOOK_URL}
                  target="_blank"
                  rel="noreferrer noopener"
                  data-testid="facebook-follow-btn"
                  className="pill-btn border-2 border-foreground/25 text-foreground hover:border-primary hover:text-primary"
                >
                  <Facebook className="w-4 h-4" strokeWidth={2.4} />
                  Facebook
                </a>
              </div>
            </div>
          )}
        </Reveal>
      </div>
    </section>
  );
}
